/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Link, NavLink } from "react-router-dom";
import { FooterContact } from "./footer-column/footer-contact";
import { FooterLocation } from "./footer-column/footer-location";
import { ReactComponent as SimpliCityLogo } from "cms/assets/images/SimpliCity-logo-white.svg";
import { FooterLandAck } from "./footer-land-ack";

const Footer = () => {
    return (
        <div className="footer">
            <FooterLandAck />
            <div className="main-footer">
                <div className="page-footer">
                    <div className={"page-footer-content"}>
                        <Link to="/" className="simplicity-logo footer-column">
                            <SimpliCityLogo alt="simplicity-logo" />
                        </Link>
                        <FooterLocation />
                        <FooterContact />
                    </div>
                </div>
                <div className={"page-copyright"}>
                    <div className={"page-copyright-content"}>
                        <p>© 2019-{new Date().getFullYear()} SimpliCity<sup>™</sup> is a registered trademark of SimpliCity Digital Inc. All rights reserved.</p>
                        <ul>
                            <li>
                                <p>
                                    Built with SimpliCity<sup>™</sup>
                                </p>
                            </li>
                            <li>
                                <div>
                                    <NavLink
                                        aria-label="Privacy Policy"
                                        to="/privacy"
                                    >
                                        Privacy Policy
                                    </NavLink>
                                </div>
                                <div>
                                    <NavLink
                                        aria-label="Terms of Service"
                                        to="/terms"
                                    >
                                        Terms of Service
                                    </NavLink>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { Footer };
